import { cn } from "../../../lib/utils";
import {
  FileCode,
  AlertTriangle,
  Key,
  Link,
  Layers,
  ExternalLink,
  Map,
  FileWarning,
  Code2,
} from "lucide-react";

// Framework logo icons as inline SVGs
const FrameworkIcons: Record<string, React.ReactNode> = {
  react: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z"/>
    </svg>
  ),
  vue: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M24,1.61H14.06L12,5.16,9.94,1.61H0L12,22.39ZM12,14.08,5.16,2.23H9.59L12,6.41l2.41-4.18h4.43Z"/>
    </svg>
  ),
  angular: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M9.931 12.645h4.138l-2.07-4.908m0-7.737L.68 3.982l1.726 14.771L12 24l9.596-5.242L23.32 3.984 11.999.001zm7.064 18.31h-2.638l-1.422-3.503H8.996l-1.422 3.504h-2.64L12 2.65z"/>
    </svg>
  ),
  "next.js": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M11.5725 0c-.1763 0-.3098.0013-.3584.0067-.0516.0053-.2159.021-.3636.0328-3.4088.3073-6.6017 2.1463-8.624 4.9728C1.1004 6.584.3802 8.3666.1082 10.255c-.0962.659-.108.8537-.108 1.7474s.012 1.0884.108 1.7476c.652 4.506 3.8591 8.2919 8.2087 9.6945.7789.2511 1.6.4223 2.5337.5255.3636.04 1.9354.04 2.299 0 1.6117-.1783 2.9772-.577 4.3237-1.2643.2065-.1056.2464-.1337.2183-.1573-.0188-.0139-.8987-1.1938-1.9543-2.62l-1.919-2.592-2.4047-3.5583c-1.3231-1.9564-2.4117-3.556-2.4211-3.556-.0094-.0026-.0187 1.5787-.0235 3.509-.0067 3.3802-.0093 3.5162-.0516 3.596-.061.115-.108.1618-.2064.2134-.075.0374-.1408.0445-.495.0445h-.406l-.1078-.068a.4383.4383 0 01-.1572-.1712l-.0493-.1056.0053-4.703.0067-4.7054.0726-.0915c.0376-.0493.1174-.1125.1736-.143.0962-.047.1338-.0517.5765-.0517.5765 0 .6481.0186.7898.1547.0376.0374 1.3371 1.9987 2.8909 4.3608 1.5537 2.362 3.9565 6.0154 5.3374 8.1178l2.5095 3.8218.127-.0844c1.1256-.7392 2.3171-1.792 3.2686-2.8856 2.024-2.3258 3.3194-5.2143 3.6608-8.1713.0962-.659.108-.8537.108-1.7476 0-.8938-.012-1.0884-.108-1.7474C23.6192 5.2682 20.9572 1.4 17.1054.3528 16.317.0987 15.4938-.0736 14.5665-.027c-.3165.0186-1.0114.0748-1.9434.1547z"/>
    </svg>
  ),
  nuxt: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M13.464 19.83H2.756a1.244 1.244 0 01-1.076-.621 1.245 1.245 0 010-1.24l6.606-11.39a1.244 1.244 0 012.152 0l1.62 2.794 3.083-5.317a1.244 1.244 0 012.152 0l6.083 10.49a1.244 1.244 0 01-1.076 1.866h-4.036a2.488 2.488 0 01-2.152-1.242l-2.778-4.788-2.318 4.002 1.52 2.62a.622.622 0 01-.538.932h-3.78a.622.622 0 01-.538-.932l1.519-2.62-2.316-3.998-4.29 7.4h8.89c.544 0 .869.606.538.931l-.001.002-.001.002-.001.002-.001.002-.001.002-.001.001-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.001-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.001-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.001-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.002-.001.001-.001.002c-.158.159-.373.249-.597.25zm5.796-1.116h4.984l-5.545-9.57-2.318 3.998z"/>
    </svg>
  ),
  svelte: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M20.68 2.796a6.587 6.587 0 00-8.998-1.612L6.18 4.908a5.573 5.573 0 00-2.532 3.731 5.768 5.768 0 00.532 3.805 5.476 5.476 0 00-.843 2.118 5.893 5.893 0 001.018 4.642 6.587 6.587 0 008.998 1.612l5.502-3.724a5.573 5.573 0 002.532-3.731 5.768 5.768 0 00-.532-3.805 5.476 5.476 0 00.843-2.118 5.893 5.893 0 00-1.018-4.642zm-9.819 17.6a4.063 4.063 0 01-4.378-1.645 3.63 3.63 0 01-.623-2.862 3.533 3.533 0 01.126-.46l.112-.337.306.217a6.733 6.733 0 002.054 1.14l.195.06-.018.193a1.095 1.095 0 00.21.765 1.255 1.255 0 001.351.507 1.153 1.153 0 00.322-.126l5.502-3.724a1.074 1.074 0 00.49-.723 1.12 1.12 0 00-.193-.882 1.255 1.255 0 00-1.351-.507 1.153 1.153 0 00-.322.126l-2.1 1.42a3.705 3.705 0 01-1.038.406 4.063 4.063 0 01-4.378-1.645 3.63 3.63 0 01-.623-2.862 3.447 3.447 0 011.558-2.312l5.502-3.724a3.705 3.705 0 011.038-.406 4.063 4.063 0 014.378 1.645 3.63 3.63 0 01.623 2.862 3.533 3.533 0 01-.126.46l-.112.337-.306-.217a6.733 6.733 0 00-2.054-1.14l-.195-.06.018-.193a1.095 1.095 0 00-.21-.765 1.255 1.255 0 00-1.351-.507 1.153 1.153 0 00-.322.126l-5.502 3.724a1.074 1.074 0 00-.49.723 1.12 1.12 0 00.193.882 1.255 1.255 0 001.351.507 1.153 1.153 0 00.322-.126l2.1-1.42a3.705 3.705 0 011.038-.406 4.063 4.063 0 014.378 1.645 3.63 3.63 0 01.623 2.862 3.447 3.447 0 01-1.558 2.312l-5.502 3.724a3.705 3.705 0 01-1.038.406z"/>
    </svg>
  ),
  jquery: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M1.525 13.089a10.62 10.62 0 0 0 5.063 4.91c2.397 1.252 5.263 1.498 7.852.69a10.625 10.625 0 0 0 5.854-4.585 10.615 10.615 0 0 0 1.414-4.05A9.14 9.14 0 0 1 18.91 15.6a9.11 9.11 0 0 1-5.388 2.454A9.14 9.14 0 0 1 7.043 16.2a9.133 9.133 0 0 1-4.1-4.44 9.116 9.116 0 0 1-.627-3.336c-.05-.163-.092-.328-.14-.496a10.6 10.6 0 0 0-.65 5.16zM5.86 7.556a6.77 6.77 0 0 0 .19 4.016 6.79 6.79 0 0 0 3.045 3.625 6.772 6.772 0 0 0 4.629.645 6.768 6.768 0 0 0 4.108-2.913 6.777 6.777 0 0 0 .994-2.058 5.633 5.633 0 0 1-1.887 3.03 5.636 5.636 0 0 1-3.254 1.296 5.634 5.634 0 0 1-3.45-.808 5.632 5.632 0 0 1-2.283-2.7 5.618 5.618 0 0 1-.347-1.668 5.62 5.62 0 0 1-.032-.627c-.05-.127-.093-.257-.14-.392a6.76 6.76 0 0 0-.573 1.447zM9.19 3.977a3.875 3.875 0 0 0 .112 2.256 3.876 3.876 0 0 0 1.73 2.063 3.876 3.876 0 0 0 2.634.375 3.876 3.876 0 0 0 2.338-1.659 3.86 3.86 0 0 0 .57-1.175 3.2 3.2 0 0 1-1.087 1.725 3.21 3.21 0 0 1-1.855.736 3.21 3.21 0 0 1-1.965-.462 3.209 3.209 0 0 1-1.303-1.538 3.22 3.22 0 0 1-.195-.953 2.85 2.85 0 0 1-.018-.36c-.033-.08-.06-.16-.09-.243a3.832 3.832 0 0 0-.325.83z"/>
    </svg>
  ),
  webpack: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M22.199 18.498l-9.71 5.46v-4.367l6.047-3.317 3.663 2.224zm.623-.623l-3.725-2.263.058-6.152 3.667 2.16v6.255zM1.177 18.498l9.71 5.46v-4.367l-6.047-3.317-3.663 2.224zm-.623-.623l3.725-2.263-.058-6.152L.554 11.62v6.255zm.388-6.913l3.792 2.236 6.14-3.396V5.442L1.254 10.9l-.312.062zm21.494 0l-3.792 2.236-6.14-3.396V5.442l9.62 5.458.312.062zm-11.238 9.052l-5.96-3.297v-6.563l5.96 3.456v6.404zm.578 0l5.96-3.297v-6.563l-5.96 3.456v6.404zm-6.262-10.24l6.001-3.32 6.001 3.32-6.001 3.477-6.001-3.478z"/>
    </svg>
  ),
  typescript: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z"/>
    </svg>
  ),
  bootstrap: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M11.77 11.24H9.956V8.202h2.152c1.17 0 1.834.522 1.834 1.466 0 1.008-.773 1.572-2.174 1.572zm.324 1.206H9.957v3.348h2.231c1.459 0 2.232-.585 2.232-1.685s-.795-1.663-2.326-1.663zM24 11.39v1.218c-1.128.108-1.817.944-2.226 2.268-.407 1.319-.463 2.937-.42 4.186.045 1.3-.968 2.5-2.337 2.5H4.985c-1.37 0-2.383-1.2-2.337-2.5.043-1.249-.013-2.867-.42-4.186-.41-1.324-1.1-2.16-2.228-2.268V11.39c1.128-.108 1.819-.944 2.227-2.268.408-1.319.464-2.937.42-4.186-.045-1.3.968-2.5 2.338-2.5h14.032c1.37 0 2.382 1.2 2.337 2.5-.043 1.249.013 2.867.42 4.186.409 1.324 1.098 2.16 2.226 2.268zm-7.927 2.817c0-1.354-.953-2.333-2.368-2.488v-.057c1.04-.169 1.856-1.135 1.856-2.213 0-1.537-1.213-2.538-3.062-2.538h-4.16v10.172h4.181c2.218 0 3.553-1.086 3.553-2.876z"/>
    </svg>
  ),
  tailwind: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M12.001 4.8c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624C13.666 10.618 15.027 12 18.001 12c3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C16.337 6.182 14.976 4.8 12.001 4.8zm-6 7.2c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624 1.177 1.194 2.538 2.576 5.512 2.576 3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C10.337 13.382 8.976 12 6.001 12z"/>
    </svg>
  ),
  express: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M24 18.588a1.529 1.529 0 01-1.895-.72l-3.45-4.771-.5-.667-4.003 5.444a1.466 1.466 0 01-1.802.708l5.158-6.92-4.798-6.251a1.595 1.595 0 011.9.666l3.576 4.83 3.596-4.81a1.435 1.435 0 011.788-.668L21.708 7.9l-2.522 3.283a.666.666 0 000 .994l4.804 6.412zM.002 11.576l.42-2.075c1.154-4.103 5.858-5.81 9.094-3.27 1.895 1.489 2.368 3.597 2.275 5.973H1.116C.943 16.447 4.005 19.009 7.92 17.7a4.078 4.078 0 002.582-2.876c.207-.666.548-.78 1.174-.588a5.417 5.417 0 01-2.589 3.957 6.272 6.272 0 01-7.306-.933 6.575 6.575 0 01-1.64-3.858c0-.235-.08-.455-.134-.666A88.33 88.33 0 010 11.577zm1.127-.286h9.654c-.06-3.076-2.001-5.258-4.59-5.278-2.882-.04-4.944 2.094-5.071 5.264z"/>
    </svg>
  ),
  laravel: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M23.642 5.43a.364.364 0 01.014.1v5.149c0 .135-.073.26-.189.326l-4.323 2.49v4.934a.378.378 0 01-.188.326L9.93 23.949a.316.316 0 01-.066.027c-.008.002-.016.008-.024.01a.348.348 0 01-.192 0c-.011-.002-.02-.008-.03-.012-.02-.008-.042-.014-.062-.025L.533 18.755a.376.376 0 01-.189-.326V2.974c0-.033.005-.066.014-.098.003-.012.01-.02.014-.032a.369.369 0 01.023-.058c.004-.013.015-.022.023-.033l.033-.045c.012-.01.025-.018.037-.027.014-.012.027-.024.041-.034H.53L5.043.05a.375.375 0 01.375 0L9.93 2.647h.002c.015.01.027.021.04.033l.038.027c.013.014.02.03.033.045.008.011.02.021.025.033.01.02.017.038.024.058.003.011.01.021.013.032.01.031.014.064.014.098v9.652l3.76-2.164V5.527c0-.033.004-.066.013-.098.003-.01.01-.02.013-.032a.487.487 0 01.024-.059c.007-.012.018-.02.025-.033.012-.015.021-.03.033-.043.012-.012.025-.02.037-.028.014-.01.026-.023.041-.032h.001l4.513-2.598a.375.375 0 01.375 0l4.513 2.598c.016.01.027.021.042.031.012.01.025.018.036.028.013.014.022.03.034.044.008.012.019.021.024.033.011.02.018.04.024.06.006.01.012.021.015.032zm-.74 5.032V6.179l-1.578.908-2.182 1.256v4.283zm-4.51 7.75v-4.287l-2.147 1.225-6.126 3.498v4.325zM1.093 3.624v14.588l8.273 4.761v-4.325l-4.322-2.445-.002-.003H5.04c-.014-.01-.025-.021-.04-.031-.011-.01-.024-.018-.035-.027l-.001-.002c-.013-.012-.021-.025-.031-.04-.01-.011-.021-.022-.028-.036h-.002c-.008-.014-.013-.031-.02-.047-.006-.016-.014-.027-.018-.043a.49.49 0 01-.008-.057c-.002-.014-.006-.027-.006-.041V5.789l-2.18-1.257zM5.23.81L1.47 2.974l3.76 2.164 3.758-2.164zm1.956 13.505l2.182-1.256V3.624l-1.58.91-2.182 1.255v9.435zm11.581-10.95l-3.76 2.163 3.76 2.163 3.759-2.164zm-.376 4.978L16.21 7.087l-1.58-.907v4.283l2.182 1.256 1.58.908zm-8.65 9.654l5.514-3.148 2.756-1.572-3.757-2.163-4.324 2.49-3.94 2.27z"/>
    </svg>
  ),
  django: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M11.146 0h3.924v18.166c-2.013.382-3.491.535-5.096.535-4.791 0-7.288-2.166-7.288-6.32 0-4.002 2.65-6.6 6.753-6.6.637 0 1.121.05 1.707.203zm0 9.143a3.894 3.894 0 00-1.325-.204c-1.988 0-3.134 1.223-3.134 3.365 0 2.09 1.096 3.236 3.109 3.236.433 0 .79-.025 1.35-.102V9.142zM21.314 6.06v9.098c0 3.134-.229 4.638-.917 5.937-.637 1.249-1.478 2.039-3.211 2.905l-3.644-1.733c1.733-.815 2.574-1.53 3.109-2.625.561-1.121.739-2.421.739-5.835V6.059h3.924zM17.39.021h3.924v4.026H17.39z"/>
    </svg>
  ),
  rails: (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M.741 18.096h9.787L8.55 24H.741zm0-6.336h8.96l-1.12 5.377H.742zm4.975-5.377h6.09l-1.05 4.418H.74zm5.73-5.424h7.35l-1.092 4.466H9.53zm5.684-.959h6.128V7.383h-5.04zm0 6.336h4.128l.02 5.424h-5.27zm-5.73 0h5.67l1.12 5.424h-5.67zm1.12 5.472h5.67l1.12 5.377h-5.77zm4.62 5.424l.6 2.672.5 2.705h-6.87l1.12-5.377z"/>
    </svg>
  ),
};

// Get framework icon by name (case-insensitive, handles variations)
function getFrameworkIcon(name: string): React.ReactNode {
  const normalizedName = name.toLowerCase().replace(/[.\s]/g, "");

  // Try exact match first
  if (FrameworkIcons[normalizedName]) {
    return FrameworkIcons[normalizedName];
  }

  // Try common variations
  const variations: Record<string, string> = {
    "reactjs": "react",
    "vuejs": "vue",
    "vue.js": "vue",
    "angularjs": "angular",
    "nextjs": "next.js",
    "nuxtjs": "nuxt",
    "nuxt.js": "nuxt",
    "sveltejs": "svelte",
    "tailwindcss": "tailwind",
    "expressjs": "express",
  };

  const variation = variations[normalizedName];
  if (variation && FrameworkIcons[variation]) {
    return FrameworkIcons[variation];
  }

  // Default icon
  return <Code2 className="w-4 h-4" />;
}

const IntegrationIcons: Record<string, React.ReactNode> = {
  "google analytics": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M22.84 2.998v17.99a2.993 2.993 0 0 1-4.202 2.735 2.994 2.994 0 0 1-1.779-2.735v-17.99a2.99 2.99 0 0 1 5.025-2.186c.622.622.957 1.42.957 2.186zM14.49 12.003v8.985a2.99 2.99 0 0 1-5.98 0v-8.985a2.992 2.992 0 0 1 5.026-2.186c.622.622.956 1.42.955 2.186zM6.14 18.498a2.99 2.99 0 1 1-5.98 0 2.99 2.99 0 0 1 5.98 0z"/>
    </svg>
  ),
  "hotjar": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M18.42 2.882c0-1.018-.627-1.768-1.953-1.768-2.399 0-5.378 3.159-7.77 3.159-.685 0-1.07-.36-1.07-.9 0-1.018.987-2.237.987-3.015C8.614.12 8.41 0 8.146 0 6.913 0 5.34 2.942 5.34 4.95c0 1.588.988 2.546 2.554 2.546 2.579 0 5.498-3.159 7.77-3.159.505 0 .81.24.81.72 0 .958-.928 2.117-.928 2.895 0 .24.12.36.385.36 1.232 0 2.489-2.942 2.489-5.43zM18.66 16.507c0-1.588-.987-2.546-2.554-2.546-2.58 0-5.498 3.159-7.77 3.159-.506 0-.81-.24-.81-.72 0-.958.928-2.117.928-2.895 0-.24-.12-.36-.385-.36-1.233 0-2.49 2.942-2.49 5.43 0 1.018.628 1.768 1.954 1.768 2.398 0 5.378-3.159 7.77-3.159.685 0 1.07.36 1.07.9 0 1.018-.988 2.237-.988 3.015 0 .24.204.36.468.36 1.233 0 2.807-2.942 2.807-4.951z"/>
    </svg>
  ),
  "datadog": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M19.098 16.078l-1.728-.388-.252-.053-1.088-1.89-.053-.107a8.74 8.74 0 0 0-.107-.16l.266-.186c.266-.186.506-.4.718-.64.133-.133.24-.293.346-.426.08-.133.16-.266.213-.4.08-.186.133-.4.16-.612a2.14 2.14 0 0 0-.08-.826 1.84 1.84 0 0 0-.48-.746c-.186-.186-.426-.346-.692-.453-.24-.107-.506-.16-.772-.186-.213-.027-.426-.027-.639-.027h-.027l-.266.027c-.08-.08-.186-.16-.266-.24l-.48-.426-.639-.56c.293-.053.586-.133.852-.24a3.4 3.4 0 0 0 1.542-1.196c.346-.506.506-1.116.48-1.728a2.93 2.93 0 0 0-.506-1.596 3.3 3.3 0 0 0-1.302-1.062c-.56-.266-1.168-.4-1.782-.4H9.262l-.027.027v7.758l-.027.027-2.57-2.57-.24-.266-.053-.053c-.186-.213-.4-.4-.639-.56a2.52 2.52 0 0 0-.826-.346c-.16-.053-.32-.053-.48-.053-.293 0-.56.053-.826.186-.24.107-.453.293-.612.506a1.71 1.71 0 0 0-.266.692 1.89 1.89 0 0 0 .027.772c.053.24.133.453.266.666.133.213.293.426.48.612.053.053.08.107.133.133l4.31 4.31v.027l.027.027v3.868l-.053.027-5.976-4.59-.08-.053c-.293-.213-.612-.4-.932-.56a3.45 3.45 0 0 0-1.062-.293 1.84 1.84 0 0 0-.826.08c-.266.08-.506.24-.692.453a1.59 1.59 0 0 0-.346.666c-.053.266-.053.533.027.8.08.293.213.56.4.8.186.266.426.48.666.692l8.278 7.002.053.027 3.548 1.568.08.027 5.578-1.568.027-.053V16.078zM12.082 4.546h.932c.32 0 .612.053.905.186.24.107.453.293.586.533.133.213.186.48.16.746a1.39 1.39 0 0 1-.346.826c-.213.24-.48.426-.772.533-.346.133-.718.186-1.088.186h-.4V4.546h.027zm0 7.304V8.69h.133c.053.053.133.107.186.16l2.464 2.17.16.133c-.16.027-.293.053-.426.107-.213.08-.4.213-.56.373-.16.16-.293.346-.4.56l-.266.56a.34.34 0 0 1-.053.08l-1.248-1.035.027.027z"/>
    </svg>
  ),
  "facebook pixel": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  "stripe": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z"/>
    </svg>
  ),
  "google tag manager": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M12.003 0a3.4 3.4 0 0 0-3.4 3.4v6.2l-2-2a3.399 3.399 0 1 0-4.807 4.808L9.4 20.01a3.4 3.4 0 0 0 4.808 0l7.603-7.602a3.4 3.4 0 0 0 0-4.808L14.207 0h-2.204zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/>
    </svg>
  ),
  "sentry": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M13.91 2.505c-.873-1.448-2.972-1.448-3.844 0L6.572 8.17a9.2 9.2 0 0 1 5.335 8.449h-2.27a6.93 6.93 0 0 0-4.009-6.36l-2.4 3.98a3.7 3.7 0 0 1 2.13 3.34H1.488c0-.468-.081-.604-.2-.86l-1.2 1.992c-.873 1.448.218 3.257 1.922 3.257H7.99v-2.27H2.01c-.024 0-.062-.042-.042-.078L3.49 16.62a6.1 6.1 0 0 1 1.348 3.837h2.27a8.3 8.3 0 0 0-1.832-5.218l1.6-2.652A10.47 10.47 0 0 1 10.562 19.5v2.958h2.27V16.62a11.76 11.76 0 0 0-5.14-9.748l1.922-3.186c.024-.042.078-.042.102 0l8.438 13.986c.024.042-.012.078-.042.078h-2.27v2.27h2.27c1.704 0 2.795-1.81 1.922-3.257z"/>
    </svg>
  ),
  "intercom": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M20.333 0H3.667C1.643 0 0 1.643 0 3.667v16.666C0 22.357 1.643 24 3.667 24h16.666C22.357 24 24 22.357 24 20.333V3.667C24 1.643 22.357 0 20.333 0zM5.333 14.333V7c0-.368.299-.667.667-.667s.667.299.667.667v7.333c0 .368-.299.667-.667.667s-.667-.299-.667-.667zm4 2V5.667c0-.368.299-.667.667-.667s.667.299.667.667v10.666c0 .368-.299.667-.667.667s-.667-.299-.667-.667zm4 0V5.667c0-.368.299-.667.667-.667s.667.299.667.667v10.666c0 .368-.299.667-.667.667s-.667-.299-.667-.667zm4-2V7c0-.368.299-.667.667-.667s.667.299.667.667v7.333c0 .368-.299.667-.667.667s-.667-.299-.667-.667zm2.084 5.148c-.08.048-2.024 1.185-7.417 1.185s-7.337-1.137-7.417-1.185a.669.669 0 0 1-.232-.915.67.67 0 0 1 .916-.231c.021.013 1.81 1.064 6.733 1.064 4.954 0 6.721-1.056 6.738-1.066a.666.666 0 0 1 .679 1.148z"/>
    </svg>
  ),
  "mixpanel": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <circle cx="5" cy="12" r="4"/>
      <circle cx="12" cy="12" r="4"/>
      <circle cx="19" cy="12" r="4"/>
    </svg>
  ),
  "segment": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M13.1 8.76h8.26a.63.63 0 1 0 0-1.26H13.1a.63.63 0 1 0 0 1.26zM2.64 16.5h8.26a.63.63 0 1 0 0-1.26H2.64a.63.63 0 0 0 0 1.26zm18.09-.48a.62.62 0 0 0-.87.12A8.24 8.24 0 0 1 13.2 20a8.24 8.24 0 0 1-7.6-5.07.63.63 0 1 0-1.16.49A9.5 9.5 0 0 0 13.2 21.26a9.5 9.5 0 0 0 7.65-3.87.63.63 0 0 0-.12-.87zM3.27 7.98a.63.63 0 0 0 .87-.12A8.24 8.24 0 0 1 10.8 4a8.24 8.24 0 0 1 7.6 5.07.63.63 0 1 0 1.16-.49A9.5 9.5 0 0 0 10.8 2.74 9.5 9.5 0 0 0 3.15 6.6a.63.63 0 0 0 .12.87z"/>
    </svg>
  ),
  "paypal": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z"/>
    </svg>
  ),
  "google ads": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M3.9 12l6.1 10.6c1.1 1.9 3.5 2.5 5.4 1.4 1.9-1.1 2.5-3.5 1.4-5.4L10.7 8 3.9 12zM20.1 2.4L14 12.6l3.4 5.8L23.5 7.8c1.1-1.9.4-4.3-1.5-5.4-1.8-1.1-4.3-.4-5.4 1.5-.1 0 0-.1 0 0l3.5-1.5zM4 17.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8z"/>
    </svg>
  ),
  "cloudflare": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M16.509 16.516c.167-.476.082-.912-.236-1.218-.298-.286-.728-.447-1.208-.467l-10.152-.147a.188.188 0 0 1-.164-.098.19.19 0 0 1 .002-.19c.04-.07.11-.118.191-.127l10.24-.147c1.248-.056 2.601-1.078 3.078-2.318l.604-1.572a.32.32 0 0 0 .015-.178c-.826-3.89-4.297-6.795-8.436-6.795-4.72 0-8.559 3.766-8.706 8.452a3.71 3.71 0 0 0-2.64 1.076A3.58 3.58 0 0 0 0 16.073a.146.146 0 0 0 .146.165h15.95c.085 0 .16-.054.188-.135l.225-.587z"/>
      <path d="M19.785 9.061a.2.2 0 0 0-.193-.052 2.46 2.46 0 0 0-.768.289.19.19 0 0 0-.087.183 3.37 3.37 0 0 1-.068 1.273c-.437 1.56-1.81 2.695-3.413 2.823l-.09.008c-.5.04-.89.453-.89.956v.55c0 .583.399 1.092.963 1.202a9.46 9.46 0 0 0 1.89.196c3.168 0 5.986-1.57 7.704-3.974a.183.183 0 0 0-.05-.266 4.47 4.47 0 0 0-4.998-2.988z"/>
    </svg>
  ),
  "aws": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M6.763 10.036c0 .296.032.535.088.71.064.176.144.368.256.576.04.063.056.127.056.183 0 .08-.048.16-.152.24l-.503.335a.383.383 0 0 1-.208.072c-.08 0-.16-.04-.239-.112a2.47 2.47 0 0 1-.287-.375 6.18 6.18 0 0 1-.248-.471c-.622.734-1.405 1.101-2.347 1.101-.67 0-1.205-.191-1.596-.574-.391-.384-.59-.894-.59-1.533 0-.678.239-1.23.726-1.644.487-.415 1.133-.623 1.955-.623.272 0 .551.024.846.064.296.04.6.104.918.176v-.583c0-.607-.127-1.03-.375-1.277-.255-.248-.686-.367-1.3-.367-.28 0-.568.032-.863.104-.296.072-.583.16-.863.272a2.287 2.287 0 0 1-.28.104.488.488 0 0 1-.127.023c-.112 0-.168-.08-.168-.247v-.391c0-.128.016-.224.056-.28a.597.597 0 0 1 .224-.167c.279-.144.614-.264 1.005-.36a4.84 4.84 0 0 1 1.246-.152c.95 0 1.644.216 2.091.647.439.43.662 1.085.662 1.963v2.586zm-3.24 1.214c.263 0 .534-.048.822-.144.287-.096.543-.271.758-.51.128-.152.224-.32.272-.512.047-.191.08-.423.08-.694v-.335a6.66 6.66 0 0 0-.735-.136 6.02 6.02 0 0 0-.75-.048c-.535 0-.926.104-1.19.32-.263.215-.39.518-.39.917 0 .375.095.655.295.846.191.2.47.296.838.296zm6.41.862c-.144 0-.24-.024-.304-.08-.064-.048-.12-.16-.168-.311L7.586 5.55a1.398 1.398 0 0 1-.072-.335c0-.128.064-.2.191-.2h.783c.151 0 .255.025.31.08.065.048.113.16.16.312l1.342 5.284 1.245-5.284c.04-.16.088-.264.151-.312a.549.549 0 0 1 .32-.08h.638c.152 0 .256.025.32.08.063.048.12.16.151.312l1.261 5.348 1.381-5.348c.048-.16.104-.264.16-.312a.52.52 0 0 1 .311-.08h.743c.128 0 .2.065.2.2 0 .04-.009.08-.017.128a1.137 1.137 0 0 1-.056.215l-1.923 6.17c-.048.16-.104.264-.168.312a.549.549 0 0 1-.32.08h-.687c-.152 0-.256-.024-.32-.08-.063-.056-.12-.16-.15-.32l-1.238-5.148-1.23 5.14c-.04.16-.087.264-.15.32-.065.056-.177.08-.32.08zm10.256.215c-.415 0-.83-.048-1.229-.143-.399-.096-.71-.2-.918-.32-.128-.071-.216-.151-.248-.22a.563.563 0 0 1-.048-.224v-.407c0-.167.064-.247.183-.247.048 0 .096.008.144.024.048.016.12.048.2.08.271.12.566.215.878.279.319.064.63.096.95.096.502 0 .894-.088 1.165-.264a.86.86 0 0 0 .415-.758.777.777 0 0 0-.215-.559c-.144-.151-.415-.287-.807-.414l-1.157-.36c-.583-.183-1.014-.454-1.277-.813a1.902 1.902 0 0 1-.4-1.158c0-.335.073-.63.216-.886.144-.255.335-.479.575-.654.24-.184.51-.32.83-.415.32-.096.655-.136 1.006-.136.176 0 .359.008.535.032.183.024.35.056.518.088.16.04.312.08.455.127.144.048.256.096.336.144a.69.69 0 0 1 .24.2.43.43 0 0 1 .071.263v.375c0 .168-.064.256-.184.256a.83.83 0 0 1-.303-.096 3.652 3.652 0 0 0-1.532-.311c-.455 0-.815.071-1.062.223-.248.152-.375.383-.375.71 0 .224.08.416.24.567.16.152.454.304.878.44l1.134.358c.574.184.99.44 1.237.767.248.328.375.703.375 1.118 0 .344-.072.655-.207.926-.144.272-.336.511-.583.703-.248.2-.543.343-.886.447-.36.111-.734.167-1.142.167zM21.698 16.207c-2.626 1.94-6.442 2.97-9.722 2.97-4.598 0-8.74-1.7-11.87-4.526-.247-.224-.024-.527.272-.352 3.384 1.963 7.559 3.153 11.877 3.153 2.914 0 6.114-.607 9.06-1.852.439-.2.814.287.383.607zM22.792 14.96c-.336-.43-2.22-.207-3.074-.103-.255.032-.295-.192-.063-.36 1.5-1.053 3.967-.75 4.254-.399.287.36-.08 2.826-1.485 4.007-.216.184-.423.088-.327-.151.32-.79 1.03-2.57.695-2.994z"/>
    </svg>
  ),
  "firebase": (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
      <path d="M3.89 15.672L6.255.461A.542.542 0 0 1 7.27.288l2.543 4.771zm16.794 3.692l-2.25-13.999a.543.543 0 0 0-.919-.295L3.316 19.365l7.856 4.427a1.621 1.621 0 0 0 1.588 0zM14.3 7.147l-1.82-3.482a.542.542 0 0 0-.96 0L3.53 17.984z"/>
    </svg>
  ),
};

function getIntegrationIcon(name: string): React.ReactNode | null {
  const key = name.toLowerCase();
  if (IntegrationIcons[key]) return IntegrationIcons[key];

  // Partial matches
  for (const [iconKey, icon] of Object.entries(IntegrationIcons)) {
    if (key.includes(iconKey) || iconKey.includes(key)) return icon;
  }
  return null;
}
import { ModuleContainer, ModuleSection } from "../ModuleContainer";
import { IssuesList, type Issue } from "../IssuesList";
import { ModuleDataTable, type ColumnDef } from "../ModuleDataTable";
import { Badge } from "../../badge";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../card";

// Types
type EndpointCategory = "api" | "graphql" | "webhook" | "internal" | "admin" | "debug" | "auth" | "upload" | "other";
type Severity = "low" | "medium" | "high" | "critical";
type Confidence = "high" | "medium" | "low";
type SecretType =
  | "aws_access_key" | "aws_secret_key" | "google_api_key" | "google_maps_key"
  | "stripe_publishable_key" | "stripe_secret_key" | "firebase_config"
  | "slack_webhook" | "slack_token" | "github_token" | "private_key"
  | "jwt_token" | "basic_auth_credential" | "database_url"
  | "generic_api_key" | "generic_secret" | "internal_url";

type IntegrationCategory = "analytics" | "payment" | "advertising" | "authentication" | "cloud_service" | "cdn" | "error_tracking" | "chat_support" | "other";

interface DiscoveredEndpoint {
  path: string;
  full_url?: string;
  category: EndpointCategory;
  http_methods: string[];
  parameters: string[];
  source_file: string;
  line_number?: number;
  confidence: Confidence;
  host?: string;
}

interface LeakedSecret {
  secret_type: SecretType;
  severity: Severity;
  value_preview: string;
  source_file: string;
  line_number?: number;
  context: string;
  confidence: Confidence;
  host?: string;
}

interface ThirdPartyIntegration {
  name: string;
  category: IntegrationCategory;
  identifiers: string[];
  endpoints_used: string[];
  confidence: Confidence;
  host?: string;
}

interface FrameworkDetection {
  name: string;
  version?: string;
  host?: string;
}

interface JsFileInfo {
  url: string;
  size_bytes: number;
  is_minified: boolean;
  is_bundled: boolean;
  has_source_map: boolean;
  source_map_url?: string;
  framework_hints: string[];
}

interface SourceMapInfo {
  url: string;
  original_files: string[];
  exposes_source: boolean;
  sensitive_paths: string[];
}

interface FrameworkDetection {
  name: string;
  version?: string;
}

export interface JsAnalysisModuleData {
  score?: number;
  target?: string;
  base_url?: string;
  js_files_analyzed?: JsFileInfo[];
  endpoints?: DiscoveredEndpoint[];
  secrets?: LeakedSecret[];
  integrations?: ThirdPartyIntegration[];
  source_maps?: SourceMapInfo[];
  webpack_detected?: boolean;
  frameworks_detected?: string[];
  frameworks_with_versions?: FrameworkDetection[];
  issues?: Array<string | Issue>;
}

export interface JsAnalysisModuleViewProps {
  data: JsAnalysisModuleData;
  isLoading?: boolean;
  error?: string | null;
  onRetry?: () => void;
  className?: string;
  /** Hide the header (useful when rendered within tabs) */
  hideHeader?: boolean;
}

// Category config
const ENDPOINT_CATEGORY_CONFIG: Record<EndpointCategory, { label: string; color: string }> = {
  api: { label: "API", color: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
  graphql: { label: "GraphQL", color: "bg-purple-500/10 text-purple-400 border-purple-500/30" },
  webhook: { label: "Webhook", color: "bg-blue-500/10 text-blue-400 border-blue-500/30" },
  internal: { label: "Internal", color: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  admin: { label: "Admin", color: "bg-red-500/10 text-red-400 border-red-500/30" },
  debug: { label: "Debug", color: "bg-orange-500/10 text-orange-400 border-orange-500/30" },
  auth: { label: "Auth", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  upload: { label: "Upload", color: "bg-pink-500/10 text-pink-400 border-pink-500/30" },
  other: { label: "Other", color: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
};

const SEVERITY_CONFIG: Record<Severity, { label: string; color: string }> = {
  critical: { label: "Critical", color: "bg-red-500/15 text-red-400 border-red-500/40" },
  high: { label: "High", color: "bg-orange-500/15 text-orange-400 border-orange-500/40" },
  medium: { label: "Medium", color: "bg-amber-500/15 text-amber-400 border-amber-500/40" },
  low: { label: "Low", color: "bg-cyan-500/15 text-cyan-400 border-cyan-500/40" },
};

const SECRET_TYPE_LABELS: Record<SecretType, string> = {
  aws_access_key: "AWS Access Key",
  aws_secret_key: "AWS Secret Key",
  google_api_key: "Google API Key",
  google_maps_key: "Google Maps Key",
  stripe_publishable_key: "Stripe Publishable Key",
  stripe_secret_key: "Stripe Secret Key",
  firebase_config: "Firebase Config",
  slack_webhook: "Slack Webhook",
  slack_token: "Slack Token",
  github_token: "GitHub Token",
  private_key: "Private Key",
  jwt_token: "JWT Token",
  basic_auth_credential: "Basic Auth",
  database_url: "Database URL",
  generic_api_key: "API Key",
  generic_secret: "Secret",
  internal_url: "Internal URL",
};

const INTEGRATION_CATEGORY_CONFIG: Record<IntegrationCategory, { label: string; color: string }> = {
  analytics: { label: "Analytics", color: "bg-blue-500/10 text-blue-400 border-blue-500/30" },
  payment: { label: "Payment", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  advertising: { label: "Ads", color: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  authentication: { label: "Auth", color: "bg-purple-500/10 text-purple-400 border-purple-500/30" },
  cloud_service: { label: "Cloud", color: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
  cdn: { label: "CDN", color: "bg-orange-500/10 text-orange-400 border-orange-500/30" },
  error_tracking: { label: "Errors", color: "bg-red-500/10 text-red-400 border-red-500/30" },
  chat_support: { label: "Chat", color: "bg-pink-500/10 text-pink-400 border-pink-500/30" },
  other: { label: "Other", color: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
};

// Normalize issues
function normalizeIssues(issues?: Array<string | Issue>): Issue[] {
  if (!issues) return [];
  return issues.map((issue, index) => {
    if (typeof issue === "string") {
      let severity: Issue["severity"] = "medium";
      let message = issue;

      // Parse severity prefix from backend (e.g., "[INFO] message")
      const prefixMatch = message.match(/^\[(INFO|WARNING|MEDIUM|HIGH|CRITICAL|LOW)\]\s*/i);
      if (prefixMatch) {
        const level = prefixMatch[1].toUpperCase();
        message = message.slice(prefixMatch[0].length);
        if (level === "INFO") severity = "info";
        else if (level === "LOW") severity = "low";
        else if (level === "MEDIUM" || level === "WARNING") severity = "medium";
        else if (level === "HIGH") severity = "high";
        else if (level === "CRITICAL") severity = "critical";
      } else if (message.toLowerCase().includes("source map") || message.toLowerCase().includes("secret")) {
        severity = "high";
      } else if (message.toLowerCase().includes("critical")) {
        severity = "critical";
      }
      return { id: `js-issue-${index}`, severity, message };
    }
    return issue;
  });
}

export function JsAnalysisModuleView({
  data,
  isLoading,
  error,
  onRetry,
  className,
  hideHeader,
}: JsAnalysisModuleViewProps) {
  const issues = normalizeIssues(data.issues);
  const endpoints = data.endpoints || [];
  const secrets = data.secrets || [];
  const integrations = data.integrations || [];
  const sourceMaps = data.source_maps || [];
  const jsFiles = data.js_files_analyzed || [];
  // Deduplicate frameworks by name (case-insensitive), aggregate hosts
  interface FrameworkWithHosts extends FrameworkDetection { hosts: string[] }
  const rawFrameworks: FrameworkDetection[] = data.frameworks_with_versions || data.frameworks_detected?.map(f => ({ name: f })) || [];
  const frameworksMap: Record<string, FrameworkWithHosts> = {};
  for (const fw of rawFrameworks) {
    const key = fw.name.toLowerCase();
    const existing = frameworksMap[key];
    if (existing) {
      if (fw.host && !existing.hosts.includes(fw.host)) {
        existing.hosts.push(fw.host);
      }
      if (fw.version && !existing.version) {
        existing.version = fw.version;
      }
    } else {
      frameworksMap[key] = { ...fw, hosts: fw.host ? [fw.host] : [] };
    }
  }
  const frameworks: FrameworkWithHosts[] = Object.values(frameworksMap);

  // Count secrets by severity
  const secretsBySeverity = secrets.reduce((acc, s) => {
    acc[s.severity] = (acc[s.severity] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  // Endpoint columns
  const endpointColumns: ColumnDef<DiscoveredEndpoint>[] = [
    {
      id: "host",
      header: "Host",
      accessor: (row) => row.host || data.target || "-",
      cell: (value) => (
        <code className="text-xs font-mono text-cyan-400">{value as string}</code>
      ),
      sortable: true,
      filterable: true,
      width: "150px",
    },
    {
      id: "category",
      header: "Type",
      accessor: (row) => row.category,
      cell: (value) => {
        const config = ENDPOINT_CATEGORY_CONFIG[value as EndpointCategory];
        return <Badge variant="outline" className={cn("text-xs", config.color)}>{config.label}</Badge>;
      },
      sortable: true,
      filterable: true,
      width: "80px",
    },
    {
      id: "path",
      header: "Endpoint",
      accessor: (row) => row.path,
      cell: (value, row) => (
        <div className="flex items-center justify-between gap-2">
          <code className="text-sm font-mono">{value as string}</code>
          {row.http_methods.length > 0 && (
            <div className="flex gap-1 shrink-0">
              {row.http_methods.map((m, i) => (
                <Badge key={i} variant="outline" className="text-xs">{m}</Badge>
              ))}
            </div>
          )}
        </div>
      ),
      sortable: true,
      filterable: true,
    },
  ];

  // Secret columns
  const secretColumns: ColumnDef<LeakedSecret>[] = [
    {
      id: "host",
      header: "Host",
      accessor: (row) => row.host || data.target || "-",
      cell: (value) => (
        <code className="text-xs font-mono text-cyan-400">{value as string}</code>
      ),
      sortable: true,
      filterable: true,
      width: "140px",
    },
    {
      id: "severity",
      header: "Severity",
      accessor: (row) => row.severity,
      cell: (value) => {
        const config = SEVERITY_CONFIG[value as Severity];
        return <Badge variant="outline" className={cn("text-xs", config.color)}>{config.label}</Badge>;
      },
      sortable: true,
      width: "80px",
    },
    {
      id: "secret_type",
      header: "Type",
      accessor: (row) => row.secret_type,
      cell: (value) => (
        <div className="flex items-center gap-2">
          <Key className="h-3 w-3 text-muted-foreground" />
          <span className="text-sm">{SECRET_TYPE_LABELS[value as SecretType] || String(value)}</span>
        </div>
      ),
      sortable: true,
      filterable: true,
      width: "150px",
    },
    {
      id: "value_preview",
      header: "Value",
      accessor: (row) => row.value_preview,
      cell: (value) => (
        <code className="text-xs font-mono bg-muted/50 px-2 py-0.5 rounded">{value as string}</code>
      ),
      width: "160px",
    },
    {
      id: "source_file",
      header: "Line",
      accessor: (row) => row.line_number?.toString() || "-",
      cell: (value) => (
        <code className="text-xs font-mono text-amber-400">{value as string}</code>
      ),
      sortable: true,
      width: "60px",
    },
    {
      id: "context",
      header: "Context",
      accessor: (row) => row.context,
      cell: (value) => (
        <div className="max-w-[400px]">
          <code className="text-xs font-mono text-muted-foreground bg-muted/30 px-2 py-1 rounded block overflow-x-auto whitespace-nowrap">
            {value as string}
          </code>
        </div>
      ),
    },
  ];

  return (
    <ModuleContainer
      moduleName="js_analysis"
      icon={FileCode}
      data={data}
      isLoading={isLoading}
      error={error}
      score={data.score}
      onRetry={onRetry}
      className={className}
      hideHeader={hideHeader}
    >
      <div className="space-y-6">
        {/* Summary */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <Card className="bg-card/50">
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground font-normal">
                JS Files
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-2xl font-bold font-mono">{jsFiles.length}</p>
            </CardContent>
          </Card>
          <Card className="bg-card/50">
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground font-normal">
                Endpoints
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-2xl font-bold font-mono text-cyan-400">{endpoints.length}</p>
            </CardContent>
          </Card>
          <Card className={cn("bg-card/50", secrets.length > 0 && "border-red-500/30")}>
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground font-normal flex items-center gap-1">
                <Key className="h-3 w-3 text-red-400" /> Secrets
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className={cn("text-2xl font-bold font-mono", secrets.length > 0 ? "text-red-400" : "text-emerald-400")}>
                {secrets.length}
              </p>
            </CardContent>
          </Card>
          <Card className={cn("bg-card/50", sourceMaps.some(s => s.exposes_source) && "border-amber-500/30")}>
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground font-normal flex items-center gap-1">
                <Map className="h-3 w-3 text-amber-400" /> Source Maps
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className={cn("text-2xl font-bold font-mono", sourceMaps.some(s => s.exposes_source) ? "text-amber-400" : "text-slate-400")}>
                {sourceMaps.length}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Critical Secrets Alert */}
        {(secretsBySeverity.critical || 0) > 0 && (
          <div className="p-4 rounded-lg bg-red-500/10 border border-red-500/30 animate-pulse">
            <div className="flex items-center gap-3">
              <FileWarning className="h-6 w-6 text-red-400" />
              <div>
                <h4 className="font-semibold text-red-400">Critical: Secrets Exposed in JavaScript</h4>
                <p className="text-sm text-muted-foreground">
                  {secretsBySeverity.critical} critical secret(s) found in client-side code. Immediate rotation required.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Source Map Warning */}
        {sourceMaps.some(s => s.exposes_source) && (
          <div className="p-4 rounded-lg bg-amber-500/10 border border-amber-500/30">
            <div className="flex items-center gap-3">
              <AlertTriangle className="h-5 w-5 text-amber-400" />
              <div>
                <h4 className="font-medium text-amber-400">Source Maps Exposing Original Code</h4>
                <p className="text-sm text-muted-foreground">
                  {sourceMaps.filter(s => s.exposes_source).length} source map(s) expose original source code. Consider disabling for production.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Frameworks */}
        {frameworks.length > 0 && (
          <div className="p-4 rounded-lg bg-muted/30 border border-border">
            <div className="flex items-center gap-2 mb-3">
              <Layers className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium">Frameworks Detected</span>
            </div>
            <div className="flex flex-wrap gap-3">
              {frameworks.map((fw, index) => (
                <div key={index} className="flex flex-col items-center gap-1 p-2 rounded-lg bg-muted/40 border border-border/50 min-w-[80px]">
                  <div className="text-muted-foreground">
                    {getFrameworkIcon(fw.name)}
                  </div>
                  <span className="text-xs font-medium text-center">{fw.name}</span>
                  {fw.version && (
                    <span className="text-[10px] text-muted-foreground">v{fw.version}</span>
                  )}
                  {fw.hosts && fw.hosts.length > 0 && (
                    <span className="text-[9px] text-cyan-400/70">
                      {fw.hosts.length === 1 ? fw.hosts[0] : `${fw.hosts.length} hosts`}
                    </span>
                  )}
                </div>
              ))}
              {data.webpack_detected && (
                <div className="flex flex-col items-center gap-1 p-2 rounded-lg bg-blue-500/10 border border-blue-500/30 min-w-[80px]">
                  <div className="text-blue-400">
                    {getFrameworkIcon("webpack")}
                  </div>
                  <span className="text-xs font-medium text-blue-400">Webpack</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Frameworks by Host - Detailed breakdown */}
        {rawFrameworks.length > 0 && rawFrameworks.some(f => f.host) && (
          <ModuleSection
            title="Frameworks by Host"
            icon={Layers}
            badge={<Badge variant="outline" className="text-xs">{rawFrameworks.length}</Badge>}
          >
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border">
                    <th className="text-left py-2 px-3 text-muted-foreground font-medium">Host</th>
                    <th className="text-left py-2 px-3 text-muted-foreground font-medium">Framework</th>
                    <th className="text-left py-2 px-3 text-muted-foreground font-medium">Version</th>
                  </tr>
                </thead>
                <tbody>
                  {rawFrameworks
                    .filter(f => f.host)
                    .sort((a, b) => (a.host || "").localeCompare(b.host || ""))
                    .map((fw, index) => (
                      <tr key={index} className="border-b border-border/50 hover:bg-muted/30">
                        <td className="py-2 px-3">
                          <code className="text-xs font-mono text-cyan-400">{fw.host}</code>
                        </td>
                        <td className="py-2 px-3">
                          <div className="flex items-center gap-2">
                            <span className="text-muted-foreground">{getFrameworkIcon(fw.name)}</span>
                            <span>{fw.name}</span>
                          </div>
                        </td>
                        <td className="py-2 px-3 text-muted-foreground">
                          {fw.version || "-"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </ModuleSection>
        )}

        {/* Third-party Integrations */}
        {integrations.length > 0 && (
          <ModuleSection
            title="Third-Party Integrations"
            icon={ExternalLink}
            badge={<Badge variant="outline" className="text-xs">{integrations.length}</Badge>}
          >
            <div className="grid gap-2 sm:grid-cols-2">
              {integrations.map((integration, index) => {
                const config = INTEGRATION_CATEGORY_CONFIG[integration.category];
                const icon = getIntegrationIcon(integration.name);
                return (
                  <div key={index} className="flex flex-col p-3 rounded-lg bg-muted/30 border border-border">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium flex items-center gap-2">
                        {icon && <span className="text-muted-foreground">{icon}</span>}
                        {integration.name}
                      </span>
                      <Badge variant="outline" className={cn("text-xs", config.color)}>
                        {config.label}
                      </Badge>
                    </div>
                    {integration.host && (
                      <code className="text-xs font-mono text-cyan-400 mt-1">{integration.host}</code>
                    )}
                    {integration.identifiers.length > 0 && (
                      <p className="text-xs text-muted-foreground truncate max-w-[200px] mt-1">
                        {integration.identifiers[0]}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </ModuleSection>
        )}

        {/* Discovered Endpoints */}
        {endpoints.length > 0 && (
          <ModuleSection
            title="Discovered Endpoints"
            icon={Link}
            badge={<Badge variant="outline" className="text-xs">{endpoints.length}</Badge>}
          >
            <ModuleDataTable
              data={endpoints}
              columns={endpointColumns}
              paginated={endpoints.length > 10}
              searchable
              searchPlaceholder="Search endpoints..."
            />
          </ModuleSection>
        )}

        {/* Leaked Secrets */}
        {secrets.length > 0 && (
          <ModuleSection
            title="Exposed Secrets"
            icon={Key}
            badge={<Badge variant="outline" className="text-xs bg-red-500/10 border-red-500/30 text-red-400">{secrets.length}</Badge>}
          >
            <ModuleDataTable
              data={secrets}
              columns={secretColumns}
              paginated={secrets.length > 10}
              searchable
              searchPlaceholder="Search secrets..."
            />
          </ModuleSection>
        )}

        {/* Issues */}
        {issues.length > 0 && (
          <ModuleSection
            title="Security Issues"
            badge={<Badge variant="outline" className="text-xs bg-amber-500/10 border-amber-500/30 text-amber-400">{issues.length}</Badge>}
          >
            <IssuesList issues={issues} groupBySeverity showCounts />
          </ModuleSection>
        )}
      </div>
    </ModuleContainer>
  );
}

JsAnalysisModuleView.displayName = "JsAnalysisModuleView";
